import { useCallback } from 'react'
import { logAction } from '@/services/auditLogService'
import { useAuth } from '@/hooks/useAuth'

interface LogActionParams {
  action: string
  entityType: string
  entityId: string
  details?: Record<string, unknown>
}

export function useLogAction() {
  const { user, churchId } = useAuth()

  return useCallback(
    (params: LogActionParams) => {
      logAction({
        ...params,
        churchId: churchId!,
        userId: user!.uid,
        userName: user!.displayName || '',
      })
    },
    [user, churchId],
  )
}
